import axios from "axios";
import { link } from "../../utils/constants";

const Axios = axios.create({
  baseURL: link,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
Axios.interceptors.request.use(
  (config: any) => {
    const authToken = localStorage.getItem("authToken");
    const activeStoreId = localStorage.getItem("activeStoreId");

    if (authToken) {
      config.headers["Authorization"] = `Bearer ${authToken}`;
    }

    if (activeStoreId) {
      config.headers["x-store-id"] = activeStoreId;
    }

    return config;
  },
  (error: any) => Promise.reject(error)
);

// Response interceptor
Axios.interceptors.response.use(
  (response: any) => response,
  (error: any) => Promise.reject(error)
);

export default Axios;
